export default __webpack_public_path__ + "static/media/releaseNotes.7692e8ed.md";